export const technologyText = {
  title: 'TECHNOLOGY',
  index: 2,
  contentItems: [
    {
      header: 'FRONTEND',
      listItems: ['NODEJS', 'REACT', 'PLAYWRIGHT', 'STORYBOOK', 'NEXTJS', 'FRAMER MOTION'],
    },
    {
      header: 'ML // AI',
      listItems: ['PYTORCH', 'TENSORFLOW', 'NUMPY // PANDAS'],
    },
    {
      header: 'CLOUD',
      listItems: ['DOCKER', 'AWS LAMBDA', 'AWS CDK', 'PIPELINES', 'AWS ECS // FARGATE', 'INTEGRATION TESTING'],
    },
    {
      header: 'BACKEND',
      listItems: ['JAX-RS', 'GRAPHQL', 'AREST', 'APACHE', 'GUICE // DAGGER', 'LOMBOK'],
    },
  ],
};
